<template>
  <v-card>
    <v-card-title>摘要</v-card-title>

    <v-card-text>
      <div class="confirm-item mb-2">
        <div class="item-label">運転者数</div>
        <div class="item-charge">
          <span>{{s_peoples}}</span>
          <small>名</small>
        </div>
      </div>
      <div v-if="!!s_couponCode" class="confirm-item mb-2">
        <div class="item-label">クーポンコード</div>
        <div class="item-charge">
          <span>{{s_couponCode}}</span>
        </div>
      </div>
      <div v-if="!!s_note" class="mb-2">
        <div>連絡事項</div>
        <pre class="mt-1 whitespace-pre-wrap">{{s_note}}</pre>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import PartBase from '@/mixins/PartBase'
import { mapState } from 'vuex'

export default {
  name: 'ConfirmRemark',
  mixins: [
    PartBase
  ],
  computed: {
    ...mapState('book', {
      s_peoples: state => state.peoples,
      s_couponCode: state => state.couponCode,
      s_note: state => state.note
    })
  }
}
</script>
